// Default imports
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import WpImage from "../components/WpImage";
import ButtonText from "./ButtonText";

const ITEMS_PER_PAGE = 9;

const Tiles = ({ items = [], activeCat, isLoaded, className }) => {
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);

    useEffect(() => {
        setVisibleCount(ITEMS_PER_PAGE);
    }, [activeCat]);

    const filteredItems = items.filter(
        (item) =>
            !activeCat || activeCat === item.cat || item.cat.includes(activeCat)
    );

    const visibleItems = filteredItems.slice(0, visibleCount);
    const hasMoreItems = visibleCount < filteredItems.length;

    const handleLoadMore = (event) => {
        event.preventDefault();
        setVisibleCount((prevValue) => prevValue + ITEMS_PER_PAGE);
    };

    return (
        <>
            <Row
                className={`tiles-row ${
                    className === "-connectivity-box"
                        ? "tiles-row--connectivity"
                        : ""
                }`}
            >
                {visibleItems.map((item, index) => {
                    const hasCoverContent = item.coverHeader || item.coverText;
                    const colSizes = hasCoverContent
                        ? "col-rg-12 col-xl-8"
                        : "col-md-12 col-lg-8";

                    return (
                        <Col
                            key={item.order || `${item.cat}-${index}`}
                            className={`col-24 ${colSizes} ${
                                isLoaded ? "" : "d-none"
                            }`}
                        >
                            <Tile
                                style={{
                                    animationDelay: `${
                                        index < 10 ? index * 0.1 : 1
                                    }s`,
                                }}
                                {...item}
                                className={className}
                            />
                        </Col>
                    );
                })}
            </Row>

            {hasMoreItems && (
                <div className="tiles-load-more">
                    <ButtonText
                        className="tiles-load-more__button"
                        variant="red-filled"
                        onClick={handleLoadMore}
                    >
                        Load More
                    </ButtonText>
                </div>
            )}
        </>
    );
};

const Tile = ({
    className,
    coverImage,
    coverHeader,
    coverText,
    tileText,
    bankingPartner,
    lists,
    ...attrs
}) => {
    const [isActive, setIsActive] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    return (
        <div
            className={`tile -light -large -connectivity ${
                isActive ? "-active" : ""
            } ${className || ""}`}
            onTouchMove={() => {
                setIsDragging(true);
            }}
            onTouchEnd={() => {
                if (!isDragging) {
                    setIsActive(!isActive);
                }
            }}
            onTouchStart={() => {
                setIsDragging(false);
            }}
            onMouseEnter={() => {
                setIsActive(true);
            }}
            onMouseLeave={() => {
                setIsActive(false);
            }}
            {...attrs}
        >
            <div className="tile__wrapper">
                {/* {bankingPartner && (
                    <div className="tile__icon">
                        <div className="hexagon">
                            <p className="tile__icon-text">
                                Premium <br />{" "}
                                <span className="tile__icon-subtext">
                                    Partner
                                </span>
                            </p>
                        </div>
                    </div>
                )} */}

                <div className="team-box__inf d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                    {coverImage && (
                        <div className="tile__cover-logo">
                            <WpImage
                                className="tile__cover-image"
                                image={coverImage}
                            />
                        </div>
                    )}

                    {(coverHeader || coverText) && (
                        <div className="tile__cover-content">
                            {coverHeader && (
                                <h3 className="tile__cover-header">
                                    {coverHeader}
                                </h3>
                            )}

                            {coverText && (
                                <p className="tile__cover-text">{coverText}</p>
                            )}
                        </div>
                    )}
                </div>

                {lists && (
                    <div className="tile__content">
                        {lists.map(({ header, text, list, link }, index) => (
                            <div key={index} className="tile__list text-center">
                                {header && (
                                    <h6
                                        className={`tile__title -mb-small -no-mt ${
                                            list?.length ? "-list-title" : ""
                                        }`}
                                    >
                                        {header}
                                    </h6>
                                )}

                                {text && (
                                    <p className="tile__text -default">
                                        {text}
                                    </p>
                                )}

                                {list && (
                                    <p className="tile__text -list">
                                        {list.map(({ item }, index) => (
                                            <span
                                                className="tile__text-item"
                                                key={index}
                                            >
                                                {item}
                                                {index < list.length - 1
                                                    ? " | "
                                                    : ""}
                                            </span>
                                        ))}
                                    </p>
                                )}

                                {link && link.url && (
                                    <ButtonText
                                        className="tile__button"
                                        variant="red"
                                        {...link}
                                    >
                                        {link?.title}
                                    </ButtonText>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {tileText && (
                    <div className="tile__content">
                        <p className="tile__text -long">{tileText}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Tiles;
